"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceAll = void 0;
function _escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}
/**
 * Funkcja replaceAll zamianiająca wszystkie wystąpienia tekstu.
 * @param str
 * @param find
 * @param replace
 * @returns
 */
var replaceAll;
exports.replaceAll = replaceAll;
// @ts-ignore
if (String.prototype.replaceAll !== undefined) {
    // @ts-ignore
    exports.replaceAll = replaceAll = function (str, find, replace) {
        // @ts-ignore
        return str.replaceAll(find, replace);
    };
}
else {
    exports.replaceAll = replaceAll = function (str, find, replace) {
        return str.replace(new RegExp(_escapeRegExp(find), 'g'), replace);
    };
}
exports.default = replaceAll;
//# sourceMappingURL=replaceAll.js.map